/** Citation highlight priority modes — standalone module to avoid circular imports with chatSlice. */
export enum CitationsHighlightMode {
    ANSWER_PRIORITY = "answer_priority",
    SEMANTIC_PRIORITY = "semantic_priority",
    SIMPLE_PRIORITY = "simple_priority",
    ONLY_ANSWER = "only_answer",
    ONLY_SEMANTIC = "only_semantic",
    ONLY_SIMPLE = "only_simple",
}

export const DEFAULT_CITATIONS_HIGHLIGHT_MODE = CitationsHighlightMode.SIMPLE_PRIORITY
